import type { ReactNode } from 'react';

import { ProductCardMedia, type ProductCardVariant } from '@vs-shop/commerce-ui/productCard';

import Link from '@vs-shop/image-link/Link';

type Props = {
  routerUrl: string;
  metaTitle: string;
  variant: ProductCardVariant;
  children: ReactNode;
};

/**
 * The card's imagery box, wrapped in the link to the product detail.
 *
 * A composing site hands this the photo and whatever hangs over it; the anchor
 * and the shared media box stay here, so no composing site restates that the
 * whole imagery box is a click target or that it prefetches nothing.
 *
 * `prefetch={false}` matches the name link in `ProductCardHeader`: a grid of
 * cards would otherwise prefetch every product on the page twice.
 */
export default function ProductCardMediaLink({ routerUrl, metaTitle, variant, children }: Props) {
  return (
    <Link href={routerUrl} title={metaTitle} prefetch={false}>
      <ProductCardMedia variant={variant}>{children}</ProductCardMedia>
    </Link>
  );
}
